import { ApiService } from "../../api.service";

export class CampLeadershipReportService {

  apiService: ApiService;

  // 静态文案
  staticDoc: any = {
    "1":{
      "title": ["学前测评","关键行动分析","学习建议","阅读说明"],
      "KAExplain": "你知道吗？能力是一系列“关键行动”来展现的，根据DDI能力字典，本能力由以下关键行动构成，一起来看看你的现状吧。",
      "instructions": [
        '本报告是为了帮你剖析学前能力水平和关键行动，提供个性化的学习建议，需注意：',
        '测评结果根据你的作答得出，主要基于心理特征，并非行为，当报告和自我评估有出入时，建议：',
        '1.想想是否<b class="text-dark">测验环境</b>影响了你的发挥；',
        '2.能力有<b class="text-dark">自我评价、他人观察</b>和<b class="text-dark">客观水平</b>三个角度，<b class="text-dark">建议收集上司和同事的反馈</b>来客观地评估你的能力。'
      ]
    },

    "2":{
      "title": ["关键行动前后对比","发展建议","阅读说明"],
      "KAExplain": "经过学习，你在本能力上的“关键行动”是否有所精进呢？一起来看看你的能力成长图吧。",
      "instructions": [
        '本报告是为了帮助你进行学习复盘，量化学习效果，针对有待提高的地方提供发展建议，以巩固学习成效，需注意：',
        '测评结果根据你的作答得出，并不完全代表你的实际表现，如报告与你对学习进步状况的预估不符，建议：',
        '1.回忆一下对相关知识的理解和技能的应用是否到位；',
        '2.看看学会的技能是否未来得及在工作中巩固应用。'
      ]
    }
  };

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  //用户操作轨迹
  setUserOperationTrack(learningPathMetaId){
    return this.apiService.ajax({
      'type':'GET',
      'url':'/sr/exposeoutapi/setAbilitySession/'+learningPathMetaId+'/2'
    });
  }

  // 获取前测报告
  getPreTestReport(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'get',
      'url': "sr/survey/beforeTestRepoteNew/"+learningPathMetaId
    }).toPromise();
  }

  // 获取后测报告
  getPostTestReport(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'get',
      'url': "sr/survey/afterTestReportNew/"+learningPathMetaId
    }).toPromise();
  }

  //获取用户是否第一次进入前后测报告
  getUserIsFirstInPreOrPostTestReport(learningPathMetaId, type){
    return this.apiService.ajax({
      'type': 'get',
      'url': "ddilearner/v1/user/exam/" + learningPathMetaId + '/' + type
    }).toPromise();
  }

  //保存用户是否第一次进去前后测报告
  saveUserFirstInPreOrPostTestReport(learningPathMetaId, type){
    return this.apiService.ajax({
      'type': 'post',
      'url': "ddilearner/v1/user/exam/" + learningPathMetaId + '/' + type
    }).toPromise();
  }

  //根据课程获取老师名字(课程名称)
  getTeacherName(courseName){
    let name = {
      "打造高效团队": "Alex",
      "解决冲突": "Alex",
      "领导力精要": "Mindy",
      "领导力启程": "Rita",
      "协作": "Mike",
      "计划与组织": "Lilith",
      "影响力": "Diana",
      "驱动变革": "Diana"
    }[courseName] || "Mindy";
    return name;
  }


  // 获取静态文案(前后测类型)
  getStaticDoc(type){
    return this.staticDoc[type.toString()];
  }


}



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-leadership-report/camp-leadership-report.service.ts